function lazyLoad() {
    if (document.querySelectorAll('.product-custom-grid').length){
        lozad('.lozad', {
            load: function(el) {
                el.src = el.dataset.src;
                el.onload = function() {
                    el.classList.add('fade')
                }
            }
        }).observe();
    }
}

export default lazyLoad;
